import { createAsyncThunk } from "@reduxjs/toolkit";

import { CustomersApi } from "@/modules/customers";

export const getPaymentProviderOptionsThunk = createAsyncThunk(
  "customers/payment-options",
  () => CustomersApi.getPaymentOptions()
);
